import React from "react";

export default function FormGroup({ children }) {
  return <form className="form-group">{children}</form>;
}
